export const educationData = [
    {
        id: 1,
        institution: 'University Of Engineering & Technology, Peshawar',
        course: 'BS Computer Science',
        startYear: '2018',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Islamia College, Peshawar',
        course: 'Intermediate',
        startYear: '2015',
        endYear: '2017'
    },
    {
        id: 3,
        institution: 'Cambridge Public High School',
        course: 'Matriculation',
        startYear: '2005',
        endYear: '2015'
    },
]